/**
 * Helpers for the "Add to Surgery Waitlist" modal's fields: checking them and shaping the request.
 */
app.service("surgeryWaitlistFormService", [
	"AppointmentAPI",
	"Session",
	function (AppointmentAPI, Session) {
		// dd/MM/yyyy to yyyy-MM-dd
		function toIsoDate(value) {
			const parts = value.split("/");
			return parts[2] + "-" + parts[1] + "-" + parts[0];
		}

		// Whether the chosen preferred-timeframe option has the value it needs. ASAP needs nothing; the
		// other two are meaningless without theirs.
		function hasRequiredTimeframe(section) {
			if (!section) {
				return true;
			}
			if (section.preferred_timeframe_type === "WEEKS") {
				return !!section.timeframe_number_of_weeks;
			}
			if (section.preferred_timeframe_type === "DATES") {
				return !!(section.timeframe_after_date && section.timeframe_before_date);
			}
			return true;
		}

		// The waitlist board draws one row per eye that has a primary procedure, so an entry with neither
		// could never be seen or actioned.
		function hasPrimaryProcedure(section) {
			return !!(section && (section.primary_procedure_od || section.primary_procedure_os));
		}

		// A copy of the section with the timezone added and only the chosen timeframe's fields kept,
		// the dates converted to UTC ISO.
		function withTimeframeForRequest(section) {
			const body = { ...section, timezone: Intl.DateTimeFormat().resolvedOptions().timeZone };

			if (body.preferred_timeframe_type !== "WEEKS") {
				delete body.timeframe_number_of_weeks;
			}
			if (body.preferred_timeframe_type === "DATES") {
				body.timeframe_before_date_UTC = moment.utc(toIsoDate(body.timeframe_before_date)).toDate().toISOString();
				body.timeframe_after_date_UTC = moment.utc(toIsoDate(body.timeframe_after_date)).toDate().toISOString();
			} else {
				delete body.timeframe_before_date_UTC;
				delete body.timeframe_after_date_UTC;
			}
			return body;
		}

		// The practice's clinicians as { name, value } options - the same list the progress note's waitlist
		// clinician comes from - with the current user marked "(Me)". The current user is added even when they
		// are not listed, so the dropdown can always default to them.
		function getClinicianOptions() {
			const currentUserId = Number(Session.userId);

			return AppointmentAPI.getAppointmentUsers(Session.practice.id).then(function (resp) {
				const options = (resp.data || []).map(function (user) {
					return { name: [user.firstName, user.lastName].filter(Boolean).join(" "), value: user.id };
				});

				if (!options.some((option) => option.value === currentUserId)) {
					options.push({ name: Session.user.firstName + " " + Session.user.lastName, value: currentUserId });
				}

				options.sort((a, b) => a.name.localeCompare(b.name));

				const me = options.find((option) => option.value === currentUserId);
				me.name += " (Me)";

				return options;
			});
		}

		return {
			hasRequiredTimeframe: hasRequiredTimeframe,
			hasPrimaryProcedure: hasPrimaryProcedure,
			withTimeframeForRequest: withTimeframeForRequest,
			getClinicianOptions: getClinicianOptions,
		};
	},
]);
